import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconAccommodation = ({ id, color, width = 22, style, ...restProps }: IProps) => {
  const viewBoxWidth = 22;
  const viewBoxHeight = 14;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M19.8 5.6V1.4c0-.8-.6-1.4-1.4-1.4H3.2c-.7 0-1.3.6-1.3 1.4v4.3c-.5.3-1 .6-1.3 1C0 7.4 0 8 0 8.2V11.1c0 1 .7 1.7 1.7 1.7h.2v.8c0 .3.3.6.6.6h1.9c.3 0 .6-.3.6-.6v-.8h11.8v.8c0 .3.3.6.6.6h1.9c.3 0 .6-.3.6-.6v-.8h.5c.9 0 1.7-.8 1.7-1.7V9.5c-.1-.2-.1-.3-.1-.5v-.8c0-1.1-.8-2-2.2-2.6zM3 1.4c0-.1.1-.2.2-.2h15.2c.1 0 .2.1.2.2v3.7c-.4-.1-.9-.3-1.5-.4 0-.2.1-.4.1-.6v-.3c0-1-.4-1.7-1-1.7h-3.8c-.6 0-1 .7-1 1.7v.5h-.7v-.5c0-1-.4-1.7-1-1.7h-4c-.6 0-1 .7-1 1.7v.9c-.6.2-1.2.3-1.7.5V1.4zm13 2.4v.8c-1.3-.2-2.5-.3-3.5-.3v-.5c0-.2 0-.4.1-.5H16v.5zm-6.6.5c-1.3 0-2.5.1-3.6.3v-.8c0-.2 0-.4.1-.5h3.5c0 .1.1.3.1.5l-.1.5c0-.1 0-.1 0 0zm11.4 6.8c0 .3-.2.5-.5.5h-1.1c-.3 0-.6.3-.6.6v.8h-.7v-.8c0-.3-.3-.6-.6-.6h-13c-.3 0-.6.3-.6.6v.8h-.6v-.8c0-.3-.3-.6-.6-.6h-.8c-.3 0-.5-.2-.5-.5v-.4c.2.1.3.1.5.1h18.7c.2 0 .3 0 .4-.1v.4zm0-2.1c0 .3-.2.5-.5.5H1.7c-.3 0-.5-.2-.5-.5v-.8-.1s0-.3.3-.7c.7-.8 2.7-2 9-2h.5c4.1 0 9.8.8 9.8 2.7V9z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconAccommodation;
